import React from 'react';
import { Button } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons';
import { Translate } from '@above-the-treeline/localization';
import WrappedRegistrationForm from '../RegistrationForm';
import { RegistrationTypes } from '../../RegistrationEnums';
import { useUser } from '../../../../../User/containers/UserDataStore';
import paths from '../../../../../../paths';
import './resetPasswordSuccessMessage.less';
import RegistrationDataStore from '../../../../../Registration/containers/RegistrationDataStore';

export default function ResetPasswordSuccessMessage() {
	const [isLoading, setIsLoading] = React.useState(false);
	const isAnonymous = useUser().isAnonymous();

	const renderReturnHomeButton = () => {
		return (
			<Button type="primary" shape="round" className="orange-ant-btn">
				<a href={paths.home()}>
					<Translate id="return_home" />
				</a>
			</Button>
		);
	};

	return (
		<div className="reset-password-success-message">
			{!isLoading && (
				<>
					<div className="success-text">
						<CheckCircleTwoTone />
						<Translate id="your_password_has_been_changed" />
					</div>
					{isAnonymous && (
						<div className="success-text">
							<Translate id="please_log_in_to_your_account" />
						</div>
					)}
				</>
			)}
			{isAnonymous ? (
				<RegistrationDataStore>
					<WrappedRegistrationForm
						type={RegistrationTypes.LogIn}
						isLoading={isLoading}
						setIsLoading={setIsLoading}
					/>
				</RegistrationDataStore>
			) : (
				renderReturnHomeButton()
			)}
		</div>
	);
}
